import { Box, chakra, Flex, HStack, Separator } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import useNavItems, { isGroupItem } from 'lib/hooks/useNavItems';
import RewardsButton from 'ui/rewards/RewardsButton';
import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';
import NetworkLogo from 'ui/snippets/networkLogo/NetworkLogo';
import DeFiDropdown from 'ui/snippets/topBar/DeFiDropdown';
import NetworkMenu from 'ui/snippets/topBar/NetworkMenu';
import Settings from 'ui/snippets/topBar/settings/Settings';
import TopBarStats from 'ui/snippets/topBar/TopBarStats';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

// import NavigationPromoBanner from '../promoBanner/NavigationPromoBanner';
import RollupStageBadge from '../RollupStageBadge';
import TestnetBadge from '../TestnetBadge';
import NavLink from './NavLink';
import NavLinkGroup from './NavLinkGroup';

const NavigationDesktop = () => {
  const { mainNavItems } = useNavItems();

  // Keep hook for future responsive behavior in this header (currently not used)

  const hasDeFiDropdown = Boolean(config.features.deFiDropdown.isEnabled);

  return (
    <Box
      borderColor="border.divider"
      borderBottomWidth="1px"
      position="sticky"
      top={ 0 }
      zIndex="sticky"
      bgColor="bg.primary"
    >
      <Flex
        display={{ base: 'none', lg: 'flex' }}
        alignItems="center"
        justifyContent="space-between"
        px={ 6 }
        py={ 3 }
        maxW={ `${ CONTENT_MAX_WIDTH }px` }
        m="0 auto"
      >
        { /* 左侧：Logo + 导航 */ }
        <Flex alignItems="center" flex={ 1 }>
          <NetworkLogo/>
          <TestnetBadge ml={ 3 }/>
          <RollupStageBadge ml={ 3 }/>
          <chakra.nav ml={ 6 }>
            <Flex as="ul" columnGap={ 4 } alignItems="center">
              { mainNavItems.map((item) => {
                if (isGroupItem(item)) {
                  return <NavLinkGroup key={ item.text } item={ item }/>;
                } else {
                  return (
                    <NavLink
                      key={ item.text }
                      item={ item }
                      noIcon
                      py={ 1.5 }
                      w="fit-content"
                    />
                  );
                }
              }) }
            </Flex>
          </chakra.nav>
        </Flex>

        { /* 右侧：设置按钮等 */ }
        <HStack
          alignItems="center"
          separator={ <Separator mx={ 2 } height={ 4 }/> }
          gap={ 2 }
        >
          { /* 网络菜单：切换不同的区块链网络 */ }
          { Boolean(config.UI.featuredNetworks.items) && <NetworkMenu/> }
          { /* 顶部统计信息：显示 Gas 价格等实时统计数据 */ }
          { !config.features.opSuperchain.isEnabled && <TopBarStats/> }
          { /* 钱包相关功能组 */ }
          { hasDeFiDropdown && (
            <HStack>
              { /* DeFi 下拉菜单：提供 DeFi 相关功能入口 */ }
              { hasDeFiDropdown && <DeFiDropdown/> }
            </HStack>
          ) }
          { /* 推广横幅：显示推广内容或广告 */ }
          { /* <NavigationPromoBanner/> */ }
          { /* 奖励按钮：查看和管理用户奖励 */ }
          { config.features.rewards.isEnabled && <RewardsButton size="sm"/> }
          { /* 用户相关功能：账户或钱包连接 */ }
          { (config.features.account.isEnabled && (
            <UserProfileDesktop buttonSize="sm"/>
          )) ||
            (config.features.blockchainInteraction.isEnabled && (
              <UserWalletDesktop buttonSize="sm"/>
            )) }
          { /* 设置按钮：打开网站设置菜单（主题、地址格式等） */ }
          <Settings/>
        </HStack>
      </Flex>
    </Box>
  );
};

export default React.memo(NavigationDesktop);
